import React, { useContext, useEffect, useState } from "react";
import { AppContext, TOGGLE_TERMS } from "../../context";

import { Button, Checkbox, Modal, ScrollArea } from "@mantine/core";
import { createStyles } from "@mantine/emotion";
import ReactMarkdown from "react-markdown";
import rehypeRaw from "rehype-raw";

const useStyles = createStyles((theme) => ({
  modalBody: {
    padding: "0",
  },
  termsText: {
    // color: theme.app.color,
    fontSize: "0.8125rem",
  },
  actionWrapper: {
    display: "flex",
    justifyContent: "end",
    gap: "1rem",
  },
  checkboxWrapper: {
    display: "flex",
    justifyContent: "end",
    margin: "1.5rem 0rem",
  },
  scrollViewport: {
    padding: "8px 20px 20px",
  },
}));

const SubscriptionTerms = ({ setGoToPayment }) => {
  const { classes } = useStyles();
  const [text, setText] = useState("");
  const [agree, setAgree] = useState(false);
  const { state, dispatch } = useContext(AppContext);
  const { config, culture, posId, showTerms, language } = state;

  useEffect(() => {
    fetch(
      `${config.baseUrl}/ee-static/checkout/pos-${posId}/Texts/terms-subscription.${culture}.md`
    )
      .then((response) => response.text())
      .then((text) => setText(text));
  }, [posId, culture]);
  const closeDialog = () => dispatch({ type: TOGGLE_TERMS });

  const submit = () => {
    closeDialog();
    setGoToPayment(true);
  };

  return (
    <Modal
      centered
      opened={showTerms}
      onClose={closeDialog}
      title={language.Payment}
      closeButtonProps={{ label: language.Close }}
      withCloseButton={false}
      size="lg"
      className="terms-modal"
      classNames={{ body: classes.modalBody }}
    >
      <div>
        <ScrollArea
          className={classes.scrollArea}
          classNames={{ viewport: classes.scrollViewport }}
        >
          <div className={classes.termsText}>
            <ReactMarkdown className="terms-text" rehypePlugins={[rehypeRaw]}>
              {text}
            </ReactMarkdown>
          </div>
          <div className={classes.checkboxWrapper}>
            <Checkbox
              value={agree}
              onChange={(e) => setAgree(e.target.checked)}
              label={language.TermsAgree}
              required={true}
              sx={{ input: { border: "1px solid black" } }}
            />
          </div>
          <div className={classes.actionWrapper}>
            <Button
              className="secondaryButton"
              variant="outline"
              onClick={closeDialog}
            >
              {language.Cancel || "Cancel"}
            </Button>
            <Button
              className="primaryButton"
              color="primary"
              disabled={!agree}
              onClick={submit}
            >
              {language.Go_To_Payment}
            </Button>
          </div>
        </ScrollArea>
      </div>
    </Modal>
  );
};

export default SubscriptionTerms;
